import _ from 'lodash';

const initialState = {
  orderLensData: null,
  frameSizeId: null,
  order: null,
  isDresdenReading: false,
  dresdenReadingData: null,
};

const mutations = {
  SHOW_ORDER_LENS_MODAL(state, data) {
    state.orderLensData = data;
    state.frameSizeId = _.get(data, 'frameSizeId');
    state.order = _.get(data, 'order');
    state.isDresdenReading = _.get(data, 'isDresdenReading', false);
    state.dresdenReadingData = _.get(data, 'dresdenReadingData', null);
    data.vm.$bvModal.show('order-lens-modal');
  },
};

const actions = {};

const moduleGetters = {};

export default {
  namespaced: true,
  state: initialState,
  getters: moduleGetters,
  actions,
  mutations,
};
